(()=>{const money=n=>`$${Number(n).toLocaleString('en-US',{maximumFractionDigits:2})}`;const analytics=(name,detail={})=>{if(window.RVVLMeta)window.RVVLMeta.track(name,detail);else{window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:name,...detail})}};document.querySelectorAll('[data-rvvl-candidate-funnel]').forEach(root=>{const radios=[...root.querySelectorAll('[name="rvvl-sop-tier"]')],access=root.querySelector('[data-rvvl-access]'),ack=root.querySelector('[data-rvvl-access-ack]'),boostInputs=[...root.querySelectorAll('[name="rvvl-boost"]')],button=root.querySelector('[data-rvvl-add-stack]'),buttonLabel=root.querySelector('[data-rvvl-add-label]'),tierRail=root.querySelector('.rvvl-commerce__tier-grid'),membership=root.querySelector('[data-rvvl-membership]'),stackSection=root.querySelector('#optional-next-steps'),addonDialog=root.querySelector('[data-rvvl-addon-dialog]'),popupAccess=root.querySelector('[data-rvvl-popup-access]'),popupBoost=root.querySelector('[data-rvvl-popup-boost]'),popupContinue=root.querySelector('[data-rvvl-popup-continue]'),popupClose=root.querySelector('[data-rvvl-popup-close]'),boostReward=root.querySelector('[data-rvvl-boost-reward]'),boostMeter=root.querySelector('[data-rvvl-boost-meter]'),boostRewardLabel=root.querySelector('[data-rvvl-boost-reward-label]'),boostRewardCopy=root.querySelector('[data-rvvl-boost-reward-copy]'),accessStatus=root.querySelector('[data-rvvl-access-status]'),clubStatus=root.querySelector('[data-rvvl-club-status]');let addonConfirmed=false;const selected=()=>radios.find(r=>r.checked)||radios[0];const centerSelected=()=>{const card=selected()?.closest('[data-tier-card]');if(card&&tierRail&&tierRail.scrollWidth>tierRail.clientWidth)tierRail.scrollLeft=card.offsetLeft-(tierRail.clientWidth-card.clientWidth)/2};const celebrate=el=>{if(!el)return;el.classList.remove('is-celebrating');requestAnimationFrame(()=>el.classList.add('is-celebrating'));setTimeout(()=>el.classList.remove('is-celebrating'),760)};const updateRewardStates=()=>{const boostOption=boostInputs.find(r=>r.checked),boostIndex=Math.max(0,boostInputs.indexOf(boostOption)),boostMax=Math.max(1,boostInputs.length-1),boostPrice=Number(boostOption?.dataset?.price||0),progress=Math.round(boostIndex/boostMax*100),state=boostIndex===0?['Recipe + vote secured','Your Recipe and verified vote are already active. Choose a Boost to put more resources behind the next candidate questions.']:boostIndex===1?['Starter boost active','A focused '+money(boostPrice)+' Boost now adds candidate-specific fuel behind the next research questions.']:progress<55?['More questions backed','Your '+money(boostPrice)+' Boost creates more room for candidate-specific research and feasibility work.']:boostIndex<boostMax?['Research runway rising','This '+money(boostPrice)+' selection puts stronger resources behind the remembered details worth investigating.']:['Maximum listed boost','You selected the strongest listed Boost for this candidate. Evidence still controls what work advances.'];if(boostReward){boostReward.style.setProperty('--rvvl-boost-progress',progress+'%');boostReward.classList.toggle('has-boost',boostIndex>0)}if(boostMeter)boostMeter.style.width=progress+'%';if(boostRewardLabel)boostRewardLabel.textContent=state[0];if(boostRewardCopy)boostRewardCopy.textContent=state[1];root.querySelectorAll('[data-rvvl-boost-unlock]').forEach(chip=>chip.classList.toggle('is-active',Number(chip.dataset.rvvlBoostUnlock)<=Math.min(boostIndex,3)));const accessCard=access?.closest('.rvvl-commerce__stack-card'),clubCard=membership?.closest('.rvvl-commerce__stack-card');accessCard?.classList.toggle('is-rewarded',!!access?.checked);clubCard?.classList.toggle('is-rewarded',!!membership?.checked);if(accessStatus)accessStatus.textContent=access?.checked?'First-window ready':'Ready to activate';if(clubStatus)clubStatus.textContent=membership?.checked?'Founding path active':'Ready to join'};const update=()=>{const tier=selected(),boostOption=boostInputs.find(r=>r.checked),boostPrice=Number(boostOption?.dataset?.price||0),accessPrice=access?.checked?29:0,membershipPrice=membership?.checked?Number(membership.dataset.price||39):0,total=Number(tier?.dataset.price||0)+boostPrice+accessPrice+membershipPrice,fuel=Number(tier?.dataset.fuel||0)+boostPrice;root.querySelectorAll('[data-tier-card]').forEach(x=>x.classList.toggle('is-selected',x.querySelector('input').checked));root.querySelector('[data-rvvl-selected-fuel]').textContent=`+${money(fuel)}`;root.querySelector('[data-rvvl-selected-total]').textContent=money(total);root.querySelector('[data-rvvl-summary-label]').textContent=`${tier?.dataset.tierName||'Recipe'}${accessPrice?' + Priority Access':''}${boostPrice?' + Boost':''}${membershipPrice?' + Founding Club':''}`;root.querySelector('[data-rvvl-summary-total]').textContent=money(total);root.querySelector('[data-rvvl-summary-fuel]').textContent=money(fuel);updateRewardStates();if(buttonLabel&&button?.dataset.rvvlAddActive==='true')buttonLabel.textContent='Add impact stack · '+money(total)};radios.forEach(r=>r.addEventListener('change',()=>{update();centerSelected();stackSection?.scrollIntoView({behavior:'smooth',block:'start'});analytics('rvvl_sop_tier_select',{candidate_id:root.dataset.candidateId,tier:r.dataset.tierName,price:Number(r.dataset.price)})}));access?.addEventListener('change',()=>{if(!access.checked&&ack)ack.checked=false;update();celebrate(access?.closest('.rvvl-commerce__stack-card'))});membership?.addEventListener('change',()=>{update();celebrate(membership?.closest('.rvvl-commerce__stack-card'))});boostInputs.forEach(r=>r.addEventListener('change',()=>{update();celebrate(boostReward);analytics('rvvl_boost_select',{candidate_id:root.dataset.candidateId,amount:Number(r.dataset.price||0)})}));popupClose?.addEventListener('click',()=>addonDialog?.close());popupContinue?.addEventListener('click',()=>{addonConfirmed=true;addonDialog?.close();button?.click()});popupBoost?.addEventListener('click',()=>{const starter=boostInputs.find(r=>Number(r.dataset.price)===10);if(starter)starter.checked=true;addonDialog?.close();update();stackSection?.scrollIntoView({behavior:'smooth',block:'start'})});popupAccess?.addEventListener('click',()=>{if(access)access.checked=true;addonDialog?.close();update();stackSection?.scrollIntoView({behavior:'smooth',block:'start'});setTimeout(()=>ack?.focus(),500)});button?.addEventListener('click',async()=>{if(button.disabled)return;const currentBoost=boostInputs.find(r=>r.checked);if(access?.checked&&!ack?.checked){ack.focus();ack.setCustomValidity('Confirm that Priority Access is separate from the physical product.');ack.reportValidity();return}ack?.setCustomValidity('');const tier=selected(),boostOption=boostInputs.find(r=>r.checked),items=[{id:Number(tier.value),quantity:1,properties:{_rvvl_candidate_id:root.dataset.candidateId,_rvvl_candidate:root.dataset.candidateName,_rvvl_candidate_slug:root.dataset.candidateSlug,_rvvl_offer_type:'sop',_rvvl_vote:'1',_rvvl_fuel:tier.dataset.fuel,_rvvl_terms_version:'2026-08-21'}}];if(access?.checked)items.push({id:Number(JSON.parse(root.querySelector('[data-rvvl-commerce-config]').textContent).priority_access.variant_id),quantity:1,properties:{_rvvl_candidate_id:root.dataset.candidateId,_rvvl_candidate:root.dataset.candidateName,_rvvl_offer_type:'priority-access',_rvvl_access_ack:'accepted',_rvvl_terms_version:'2026-08-21'}});if(membership?.checked&&membership.value){const membershipItem={id:Number(membership.value),quantity:1,properties:{_rvvl_offer_type:'membership',_rvvl_terms_version:'2026-08-21'}};if(membership.dataset.sellingPlan)membershipItem.selling_plan=Number(membership.dataset.sellingPlan);items.push(membershipItem)};if(boostOption?.value)items.push({id:Number(boostOption.value),quantity:1,properties:{_rvvl_candidate_id:root.dataset.candidateId,_rvvl_candidate:root.dataset.candidateName,_rvvl_offer_type:'rd-boost',_rvvl_vote:'0',_rvvl_terms_version:'2026-08-21'}});button.disabled=true;if(buttonLabel)buttonLabel.textContent='Building your stack…';else button.textContent='Adding…';try{const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});if(!response.ok)throw new Error('Cart add failed');analytics('rvvl_impact_stack_add',{candidate_id:root.dataset.candidateId,item_count:items.length,total:Number(root.querySelector('[data-rvvl-summary-total]').textContent.replace(/[^0-9.]/g,''))});window.location.href='/cart'}catch(error){button.disabled=false;if(buttonLabel)buttonLabel.textContent='Try building again';else button.textContent='Try again';root.querySelector('.rvvl-commerce__truth').textContent='We could not add this selection. Refresh the page or contact hi@rvvlbrands.com.'}});update();requestAnimationFrame(centerSelected)})})();


/* RVVL candidate research-cue variety */
(() => {
  const cueImagesByCandidate = {
    bonko: [
      "https://cdn.shopify.com/s/files/1/0789/1353/6171/files/bonko-i4-12-citrus-flavor-abstract-v1.webp?v=1787277988",
      "https://cdn.shopify.com/s/files/1/0789/1353/6171/files/bonko-i4-07-cross-section-v1.webp?v=1787277950",
      "https://cdn.shopify.com/s/files/1/0789/1353/6171/files/bonko-i4-10-lifestyle-v1-large.webp?v=1787277962"
    ],
    kricko: [
      "https://cdn.shopify.com/s/files/1/0789/1353/6171/files/kricko-honey-mustard-sensory-macro.png?v=1787280766",
      "https://cdn.shopify.com/s/files/1/0789/1353/6171/files/kricko-honey-mustard-cross-section.png?v=1787280771",
      "https://cdn.shopify.com/s/files/1/0789/1353/6171/files/kricko-honey-mustard-in-hand-concept.png?v=1787280777"
    ],
    "hi-jinx": [
      "https://cdn.shopify.com/s/files/1/0789/1353/6171/files/hi-jinx-i4-06-carbonation-detail.png?v=1787278335",
      "https://cdn.shopify.com/s/files/1/0789/1353/6171/files/hi-jinx-i4-01-product-cutout.png?v=1787278330",
      "https://cdn.shopify.com/s/files/1/0789/1353/6171/files/hi-jinx-i4-10-creative-desk.png?v=1787278340"
    ],
    ahem: [
      "https://cdn.shopify.com/s/files/1/0789/1353/6171/files/ahem-cookie-crisp-macro.png?v=1787283574",
      "https://cdn.shopify.com/s/files/1/0789/1353/6171/files/ahem-cookie-crisp-cross-section.png?v=1787283578",
      "https://cdn.shopify.com/s/files/1/0789/1353/6171/files/ahem-cookie-crisps-lifestyle.png?v=1787283583"
    ],
    mouthquake: [
      "https://cdn.shopify.com/s/files/1/0789/1353/6171/files/mouthquake-i4-12-sour-cue-concept.png?v=1787845293",
      "https://cdn.shopify.com/s/files/1/0789/1353/6171/files/mouthquake-i4-06-sensory-macro-concept.png?v=1787845300",
      "https://cdn.shopify.com/s/files/1/0789/1353/6171/files/mouthquake-concept-packaging-composite.png?v=1787283658"
    ],
    "crack-of-noon": [
      "https://cdn.shopify.com/s/files/1/0789/1353/6171/files/con-w2-img-006-master.png?v=1787278269",
      "https://cdn.shopify.com/s/files/1/0789/1353/6171/files/con-w2-img-007-master.png?v=1787278234",
      "https://cdn.shopify.com/s/files/1/0789/1353/6171/files/con-w2-img-009-master.png?v=1787278273"
    ]
  };
  const cueAltLabels = [
    "flavour and aroma research cue",
    "texture and format research cue",
    "moment and ritual research cue"
  ];

  const applyResearchCueImages = () => {
    const handle = location.pathname.match(/^\/pages\/([^/?#]+)/)?.[1];
    const sources = cueImagesByCandidate[handle];
    if (!sources) return;

    const candidateName =
      document.querySelector(".rvvl-commerce__hero h1")?.textContent?.trim() ||
      handle.replace(/-/g, " ");

    document.querySelectorAll(".rvvl-commerce__gallery-card").forEach((card, index) => {
      const source = sources[index];
      const image = card.querySelector("img");
      if (!source || !image || image.dataset.rvvlCueSource === source) return;

      image.removeAttribute("srcset");
      image.removeAttribute("sizes");
      image.src = source;
      image.alt = candidateName + " " + cueAltLabels[index];
      image.dataset.rvvlCueSource = source;
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyResearchCueImages, { once: true });
  } else {
    applyResearchCueImages();
  }
  document.addEventListener("shopify:section:load", applyResearchCueImages);
})();

(() => {
  const intro = document.querySelector('[data-rvvl-ahem-intro]');
  if (!intro || intro.hidden) return;

  const sequences = {
    'ahem-memory': {
      duration: 12500,
      label: 'Memory bridge · 12.5 seconds',
      scenes: [
        { at: 0, scene: 'recognition', text: 'Remember Planters PB Crisps?' },
        { at: 1350, scene: 'shell', text: 'The crisp shell.' },
        { at: 2750, scene: 'center', text: 'The creamy peanut-butter center.' },
        { at: 4250, scene: 'pause', text: 'That little bag was never big enough.', tone: 'wit' },
        { at: 5900, scene: 'loss', text: 'The shelves moved on.' },
        { at: 7200, scene: 'memory', text: 'Your memory didn’t.' },
        { at: 8500, scene: 'measure', text: 'So we studied what stayed with you.' },
        { at: 9850, scene: 'reveal', text: 'AHEM!', tone: 'ahem' },
        { at: 10750, scene: 'offer' }
      ]
    },
    'ahem-sensory': {
      duration: 12150,
      label: 'Sensory bridge · 12.2 seconds',
      scenes: [
        { at: 0, scene: 'recognition', text: 'Yeah. Those.', tone: 'wit' },
        { at: 1100, scene: 'shell', text: 'The crisp shell.' },
        { at: 2250, scene: 'center', text: 'The creamy peanut-butter center.' },
        { at: 3400, scene: 'pause', text: 'That first crack.' },
        { at: 4550, scene: 'memory', text: 'Then the center right after.' },
        { at: 5700, scene: 'loss', text: 'The shelves moved on.' },
        { at: 6850, scene: 'memory', text: 'But that crunch kept its place:' },
        { at: 8100, scene: 'memory', text: 'Still taking up shelf space in your memory.' },
        { at: 9450, scene: 'measure', text: 'So we mapped the details that refused to leave.' },
        { at: 10600, scene: 'reveal', text: 'AHEM!', tone: 'ahem' }
      ]
    },
    'ahem-sensory-v2': {
      duration: 13650,
      label: 'Sensory V2 · 13.7 seconds',
      scenes: [
        { at: 0, scene: 'recognition', text: 'Remember the crunch?' },
        { at: 1250, scene: 'shell', text: 'The crisp shell.' },
        { at: 2450, scene: 'center', text: 'The creamy peanut-butter center.' },
        { at: 3650, scene: 'pause', text: 'That first crack.' },
        { at: 4850, scene: 'loss', text: 'The shelves moved on.' },
        { at: 6100, scene: 'memory', text: 'But that crunch kept its place:' },
        { at: 7350, scene: 'memory', text: 'Still taking up shelf space in your memory.' },
        { at: 8750, scene: 'measure', text: 'So we mapped the details that refused to leave.' },
        { at: 10000, scene: 'measure', text: 'Recipe. Method. Tasting tools.' },
        { at: 11150, scene: 'measure', text: 'Ready to make at home today.' },
        { at: 12250, scene: 'reveal', text: 'AHEM!', tone: 'ahem' }
      ]
    },
    'ahem-stillthere': {
      duration: 10400,
      label: 'Still-there bridge · 10.4 seconds',
      scenes: [
        { at: 0, scene: 'loss', text: 'Gone from the shelf.' },
        { at: 1450, scene: 'memory', text: 'Still taking up shelf space in your memory.' },
        { at: 3250, scene: 'shell', text: 'Especially that first crack.' },
        { at: 4800, scene: 'center', text: 'And the peanut-butter center after it.' },
        { at: 6400, scene: 'measure', text: 'So we gave the craving a method.' },
        { at: 7750, scene: 'reveal', text: 'AHEM!', tone: 'ahem' },
        { at: 8650, scene: 'offer' }
      ]
    },
    'ahem-blueprint': {
      duration: 11800,
      label: 'Blueprint bridge · 11.8 seconds',
      scenes: [
        { at: 0, scene: 'recognition', text: 'A memory is not a recipe.' },
        { at: 1600, scene: 'shell', text: 'Until you crack it open.' },
        { at: 3100, scene: 'pause', text: 'Shell.' },
        { at: 4100, scene: 'center', text: 'Center.' },
        { at: 5100, scene: 'memory', text: 'Crunch.' },
        { at: 6100, scene: 'measure', text: 'Measured.' },
        { at: 7100, scene: 'measure', text: 'Tested.' },
        { at: 8100, scene: 'measure', text: 'Ready to make at home.' },
        { at: 9200, scene: 'reveal', text: 'AHEM!', tone: 'ahem' },
        { at: 10050, scene: 'offer' }
      ]
    },
    'ahem-littlebag': {
      duration: 11200,
      label: 'Little-bag bridge · 11.2 seconds',
      scenes: [
        { at: 0, scene: 'recognition', text: 'That little bag.' },
        { at: 1500, scene: 'pause', text: 'Still not big enough.', tone: 'wit' },
        { at: 3000, scene: 'loss', text: 'Still gone too soon.' },
        { at: 4500, scene: 'memory', text: 'We couldn’t fix the bag.' },
        { at: 6000, scene: 'measure', text: 'So we built the Recipe Guide.' },
        { at: 7450, scene: 'reveal', text: 'AHEM!', tone: 'ahem' },
        { at: 8500, scene: 'memory', text: 'Make the snack you still remember.' },
        { at: 9500, scene: 'offer' }
      ]
    },
    'ahem-president': {
      duration: 5200,
      label: 'Campaign variation · 5.2 seconds',
      scenes: [
        { at: 0, scene: 'recognition', text: 'We considered running for president.', tone: 'wit' },
        { at: 1350, scene: 'measure', text: 'Recipes looked faster.', tone: 'wit' },
        { at: 2550, scene: 'reveal', text: 'AHEM!', tone: 'ahem' },
        { at: 3350, scene: 'memory', text: 'Make the snack you still remember.' },
        { at: 4200, scene: 'offer' }
      ]
    },
    'ahem-direct': {
      duration: 1850,
      label: 'Direct bridge · 1.85 seconds',
      scenes: [
        { at: 0, scene: 'shell', text: 'Still thinking about that crunch?' },
        { at: 620, scene: 'reveal', text: 'Your Ahem! Recipe Guide is ready.' },
        { at: 1180, scene: 'offer' }
      ]
    },
    'kricko-sensory': {
      duration: 13750,
      label: 'Kricko sensory bridge · 13.8 seconds',
      scenes: [
        { at: 0, scene: 'kricko-recognition', text: 'Remember Rold Gold Honey Mustard Tiny Twists?' },
        { at: 1500, scene: 'kricko-twist', text: 'The little twist.' },
        { at: 2700, scene: 'kricko-season', text: 'The big honey-mustard hit.' },
        { at: 4000, scene: 'kricko-season', text: 'Sweet first. Sharp right after.' },
        { at: 5250, scene: 'kricko-crunch', text: 'Then that salty crunch.' },
        { at: 6500, scene: 'kricko-loss', text: 'The shelves moved on.' },
        { at: 7800, scene: 'kricko-memory', text: 'But the flavor kept looping back.' },
        { at: 9200, scene: 'kricko-memory', text: 'Still twisting around in your memory.' },
        { at: 10650, scene: 'kricko-measure', text: 'So we mapped the tang, sweetness, and snap.' },
        { at: 12250, scene: 'kricko-reveal', text: 'KRICKO', tone: 'kricko' }
      ]
    },
    'bonko-sensory': {
      duration: 15100,
      label: 'Bonko sensory bridge · 15.1 seconds',
      scenes: [
        { at: 0, scene: 'bonko-recognition', text: 'Remember Kaboom! Cereal?' },
        { at: 1550, scene: 'bonko-shapes', text: 'The bright little shapes.' },
        { at: 2850, scene: 'bonko-citrus', text: 'The bright citrus sweetness.' },
        { at: 4150, scene: 'bonko-crackle', text: 'That first crackle in cold milk.' },
        { at: 5450, scene: 'bonko-bowl', text: 'A bowl that made breakfast louder.' },
        { at: 6800, scene: 'bonko-loss', text: 'The shelves moved on.' },
        { at: 8150, scene: 'bonko-bounce', text: 'But the colors kept bouncing back.' },
        { at: 9550, scene: 'bonko-memory', text: 'Still making a small scene in your memory.' },
        { at: 11100, scene: 'bonko-measure', text: 'So we mapped the crunch, citrus, and playful mix.' },
        { at: 12800, scene: 'bonko-reveal', text: 'BONKO!', tone: 'bonko' },
        { at: 14000, scene: 'bonko-lockup', text: 'MAKE A SMALL SCENE.', tone: 'bonko-tag' }
      ]
    },
    'mouthquake-sensory': {
      duration: 15500,
      label: 'Mouthquake sensory bridge · 15.5 seconds',
      scenes: [
        { at: 0, scene: 'mouthquake-recognition', text: 'Remember SOUR-licious ZOURS?' },
        { at: 1550, scene: 'mouthquake-color', text: 'The bright little pieces.' },
        { at: 2850, scene: 'mouthquake-impact', text: 'That first sour jolt.' },
        { at: 4150, scene: 'mouthquake-shock', text: 'Sharp. Loud. Impossible to ignore.' },
        { at: 5450, scene: 'mouthquake-chew', text: 'Then the chew kept the flavor going.' },
        { at: 6800, scene: 'mouthquake-loss', text: 'The shelves moved on.' },
        { at: 8150, scene: 'mouthquake-aftershock', text: 'But your mouth remembered the impact.' },
        { at: 9600, scene: 'mouthquake-memory', text: 'Still sending aftershocks through your memory.' },
        { at: 11250, scene: 'mouthquake-measure', text: 'So we mapped the sour, chew, and finish.' },
        { at: 13050, scene: 'mouthquake-reveal', text: 'MOUTHQUAKE', tone: 'mouthquake' },
        { at: 14300, scene: 'mouthquake-lockup', text: 'SOUR WITH A POINT OF VIEW.', tone: 'mouthquake-tag' }
      ]
    }
  };

  const key = intro.dataset.rvvlIntroVariant;
  const sequence = sequences[key];
  if (!sequence) {
    intro.hidden = true;
    document.documentElement.classList.remove('rvvl-ahem-intro-active');
    return;
  }

  const line = intro.querySelector('[data-rvvl-ahem-intro-line]');
  const skip = intro.querySelector('[data-rvvl-ahem-intro-skip]');
  const variant = intro.querySelector('[data-rvvl-ahem-intro-variant]');
  const progress = intro.querySelector('.rvvl-ahem-intro__progress');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const leadIn = reducedMotion ? 0 : 1600;
  const effectiveDuration = reducedMotion ? 2400 : sequence.duration + leadIn;
  const timers = [];
  const shielded = [...document.querySelectorAll('header, main > section, footer')].map((element) => ({
    element,
    inert: element.inert
  }));
  let finished = false;

  shielded.forEach(({ element }) => { element.inert = true; });
  intro.style.setProperty('--rvvl-intro-duration', effectiveDuration + 'ms');
  skip?.remove();
  progress?.remove();
  variant?.remove();
  intro.classList.add('is-playing');

  const renderScene = (item) => {
    intro.dataset.scene = item.scene;
    intro.classList.toggle('is-offer', item.scene === 'offer');
    intro.querySelector('[data-rvvl-ahem-intro-offer]')?.setAttribute('aria-hidden', item.scene === 'offer' ? 'false' : 'true');
    if (!line) return;
    line.textContent = item.text || '';
    line.classList.remove('is-entering', 'is-wit', 'is-ahem', 'is-kricko', 'is-bonko', 'is-bonko-tag', 'is-mouthquake', 'is-mouthquake-tag');
    if (item.tone === 'wit') line.classList.add('is-wit');
    if (item.tone === 'ahem') line.classList.add('is-ahem');
    if (item.tone === 'kricko') line.classList.add('is-kricko');
    if (item.tone === 'bonko') line.classList.add('is-bonko');
    if (item.tone === 'bonko-tag') line.classList.add('is-bonko-tag');
    if (item.tone === 'mouthquake') line.classList.add('is-mouthquake');
    if (item.tone === 'mouthquake-tag') line.classList.add('is-mouthquake-tag');
    if (item.text) {
      void line.offsetWidth;
      line.classList.add('is-entering');
    }
  };

  const finish = (reason) => {
    if (finished) return;
    finished = true;
    timers.forEach(window.clearTimeout);
    intro.classList.add('is-leaving');
    document.documentElement.classList.remove('rvvl-ahem-intro-active');
    shielded.forEach(({ element, inert }) => { element.inert = inert; });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: reason === 'complete' ? 'rvvl_ahem_intro_complete' : 'rvvl_ahem_intro_skip',
      intro_variant: key,
      intro_duration_ms: Math.round(performance.now() - startedAt)
    });
    window.setTimeout(() => {
      intro.hidden = true;
      intro.setAttribute('aria-hidden', 'true');
    intro.classList.add('is-leaving');
    document.documentElement.classList.remove('rvvl-ahem-intro-active');
    shielded.forEach(({ element, inert }) => { element.inert = inert; });
    window.dataLayer = window.dataLayer || [];      document.querySelector('.rvvl-ahem-hero-actions .rvvl-commerce__button')?.focus({ preventScroll: true });
    }, reducedMotion ? 0 : 1150);
  };

  const startedAt = performance.now();
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'rvvl_ahem_intro_start', intro_variant: key });

  if (reducedMotion) {
    renderScene({ scene: 'offer' });
  } else {
    renderScene(sequence.scenes[0]);
    sequence.scenes.slice(1).forEach((item) => timers.push(window.setTimeout(() => renderScene(item), leadIn + item.at)));
  }
  timers.push(window.setTimeout(() => finish('complete'), effectiveDuration));

  document.addEventListener('keydown', (event) => {
    if (finished || intro.hidden || event.key !== 'Escape') return;
    event.preventDefault();
    finish('skip');
  });
})();

/* RVVL live preorder pack selection: cards sync to the sticky confirmation bar */
(() => {
  const bar = document.querySelector('[data-rvvl-preorder-bar]');
  const inputs = [...document.querySelectorAll('input[name="rvvl-pack-tier"]')];
  const addButton = document.querySelector('[data-rvvl-pack-add-selected]');
  if (!bar || !inputs.length || !addButton) return;
  const summaryName = bar.querySelector('[data-rvvl-pack-summary-name]');
  const summaryPrice = bar.querySelector('[data-rvvl-pack-summary-price]');
  const buttonLabel = addButton.querySelector('[data-rvvl-pack-button-label]');
  const cards = inputs.map((input) => input.closest('.rvvl-commerce__pack-option')).filter(Boolean);
  const update = () => {
    let selected = inputs.find((input) => input.checked && !input.disabled);
    if (!selected) selected = inputs[2] && !inputs[2].disabled ? inputs[2] : inputs.find((input) => !input.disabled);
    if (!selected) return;
    selected.checked = true;
    const packName = selected.dataset.packName || 'Selected pack';
    const priceLabel = selected.dataset.priceLabel || '';
    cards.forEach((card) => {
      const input = card.querySelector('input[name="rvvl-pack-tier"]');
      const active = input === selected;
      card.classList.toggle('is-selected', active);
      const status = card.querySelector('[data-rvvl-pack-status]');
      if (status && !input.disabled) status.textContent = active ? 'Selected · confirm in the bar below' : 'Select this pack';
    });
    if (summaryName) summaryName.textContent = packName;
    if (summaryPrice) summaryPrice.textContent = priceLabel;
    if (buttonLabel) buttonLabel.textContent = `Add ${packName} · ${priceLabel}`;
    addButton.dataset.variantId = selected.value;
    addButton.dataset.candidateId = selected.dataset.candidateId || '';
    addButton.dataset.candidateName = selected.dataset.candidateName || '';
    addButton.dataset.candidateSlug = selected.dataset.candidateSlug || '';
    addButton.dataset.packName = packName;
  };
  inputs.forEach((input) => input.addEventListener('change', update));
  update();
})();


/* RVVL preorder Priority Access: offer the first December fulfillment group after a physical pack is added. */
(() => {
  const preorderSlugs = new Set(['ahem', 'bonko', 'mouthquake', 'kricko']);
  const currentSlug = location.pathname.match(/^\/pages\/([^/?#]+)/)?.[1] || '';
  if (!preorderSlugs.has(currentSlug)) return;
  const root = document.querySelector('[data-rvvl-candidate-funnel]');
  const configNode = root?.querySelector('[data-rvvl-commerce-config]') || document.querySelector('[data-rvvl-commerce-config]');
  let config = {};
  try { config = JSON.parse(configNode?.textContent || '{}'); } catch (_) {}
  const priorityVariantId = Number(config?.priority_access?.variant_id || 0);
  const priorityPrice = Number(config?.priority_access?.price || 29);
  const money = value => '$' + Number(value).toLocaleString('en-US', { maximumFractionDigits: 2 });
  const analytics = (event, detail = {}) => {
    if (window.RVVLMeta) window.RVVLMeta.track(event, detail);
    else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, ...detail });
    }
  };
  const openCart = () => {
    sessionStorage.setItem('rvvl-reopen-cart', '1');
    const next = new URL(window.location.href);
    next.searchParams.set('open_cart', '1');
    window.location.assign(next.pathname + next.search + '#choose-your-pack');
  };
  let dialog;
  const buildDialog = candidateName => {
    dialog = document.querySelector('[data-rvvl-preorder-priority-dialog]');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'rvvl-preorder-priority';
      dialog.dataset.rvvlPreorderPriorityDialog = '';
      dialog.innerHTML =
        '<div class="rvvl-preorder-priority__panel">' +
          '<button class="rvvl-preorder-priority__close" type="button" aria-label="Continue without Priority Access" data-rvvl-priority-decline>×</button>' +
          '<p class="rvvl-preorder-priority__eyebrow">DECEMBER PRIORITY</p>' +
          '<div class="rvvl-preorder-priority__badge">+' + money(priorityPrice) + ' ONE TIME</div>' +
          '<h2>Want your <span data-rvvl-priority-candidate></span> order fulfilled first?</h2>' +
          '<p class="rvvl-preorder-priority__lede">Add Priority Access and your preorder enters our first December fulfillment group, ahead of standard <span data-rvvl-priority-candidate></span> preorders.</p>' +
          '<div class="rvvl-preorder-priority__queue" aria-label="Priority fulfillment position">' +
            '<div class="rvvl-preorder-priority__queue-card is-first"><small>YOUR ORDER</small><strong>FIRST GROUP</strong><span>Priority Access</span></div>' +
            '<div class="rvvl-preorder-priority__queue-arrow" aria-hidden="true">→</div>' +
            '<div class="rvvl-preorder-priority__queue-card"><small>STANDARD ORDERS</small><strong>DECEMBER QUEUE</strong><span>Fulfilled after priority</span></div>' +
          '</div>' +
          '<ul class="rvvl-preorder-priority__benefits">' +
            '<li><span>✓</span> First December fulfillment group</li>' +
            '<li><span>✓</span> Applied to this candidate preorder</li>' +
            '<li><span>✓</span> One-time ' + money(priorityPrice) + ' upgrade</li>' +
          '</ul>' +
          '<p class="rvvl-preorder-priority__message" role="status" aria-live="polite" data-rvvl-priority-message></p>' +
          '<button class="rvvl-preorder-priority__accept" type="button" data-rvvl-priority-accept><span>PRIORITIZE MY ORDER</span><strong>+' + money(priorityPrice) + '</strong></button>' +
          '<button class="rvvl-preorder-priority__decline" type="button" data-rvvl-priority-decline>Keep standard December fulfillment</button>' +
          '<p class="rvvl-preorder-priority__truth">Priority changes fulfillment order within December. It does not guarantee a specific delivery date.</p>' +
        '</div>';
      document.body.appendChild(dialog);
    }
    dialog.querySelectorAll('[data-rvvl-priority-candidate]').forEach(node => { node.textContent = candidateName; });
    return dialog;
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-rvvl-pack-add-selected]');
    const selected = document.querySelector('input[name="rvvl-pack-tier"]:checked');
    if (!button || !selected || button.disabled || button.dataset.busy === 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const variantId = Number(selected.value);
    const candidateId = selected.dataset.candidateId || '';
    const candidateName = selected.dataset.candidateName || 'this candidate';
    const candidateSlug = selected.dataset.candidateSlug || currentSlug;
    const label = button.querySelector('[data-rvvl-pack-button-label]');
    const originalLabel = label?.textContent || '';
    button.dataset.busy = 'true';
    button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Adding selected pack...';
    try {
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{
          id: variantId,
          quantity: 1,
          properties: {
            _rvvl_candidate_id: candidateId,
            _rvvl_candidate: candidateName,
            _rvvl_candidate_slug: candidateSlug,
            _rvvl_offer_type: 'physical-preorder',
            _rvvl_vote: '0',
            _rvvl_terms_version: '2026-08-30'
          }
        }] })
      });
      if (!addResponse.ok) throw new Error('Cart add failed');
      button.classList.add('is-selected');
      if (label) label.textContent = 'Added ✓';
      analytics('rvvl_preorder_pack_add', { variant_id: variantId, candidate_id: candidateId });
      openCart();
      return;
      if (!priorityVariantId) { openCart(); return; }
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(response => response.json());
      if (cart.items?.some(item => Number(item.variant_id) === priorityVariantId)) { openCart(); return; }
      const offer = buildDialog(candidateName);
      const accept = offer.querySelector('[data-rvvl-priority-accept]');
      const declines = offer.querySelectorAll('[data-rvvl-priority-decline]');
      const message = offer.querySelector('[data-rvvl-priority-message]');
      let leaving = false;
      const decline = () => {
        if (leaving) return;
        leaving = true;
        analytics('rvvl_preorder_priority_decline', { candidate_id: candidateId });
        offer.close();
        openCart();
      };
      declines.forEach(control => { control.onclick = decline; });
      offer.oncancel = cancelEvent => { cancelEvent.preventDefault(); decline(); };
      accept.onclick = async () => {
        if (leaving || accept.disabled) return;
        accept.disabled = true;
        if (message) message.textContent = 'Adding Priority Access...';
        try {
          const accessResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{
              id: priorityVariantId,
              quantity: 1,
              properties: {
                _rvvl_candidate_id: candidateId,
                _rvvl_candidate: candidateName,
                _rvvl_candidate_slug: candidateSlug,
                _rvvl_offer_type: 'priority-access',
                _rvvl_fulfillment_priority: 'first-december-group',
                _rvvl_access_ack: 'accepted',
                _rvvl_terms_version: '2026-08-30'
              }
            }] })
          });
          if (!accessResponse.ok) throw new Error('Priority add failed');
          leaving = true;
          analytics('rvvl_preorder_priority_add', { candidate_id: candidateId, price: priorityPrice });
          if (message) message.textContent = 'Priority Access added ✓';
          window.setTimeout(() => { offer.close(); openCart(); }, 350);
        } catch (_) {
          accept.disabled = false;
          if (message) message.textContent = 'Could not add Priority Access. Try again or continue with standard fulfillment.';
        }
      };
      analytics('rvvl_preorder_priority_view', { candidate_id: candidateId, price: priorityPrice });
      offer.showModal();
      window.setTimeout(() => accept.focus(), 60);
    } catch (_) {
      button.dataset.busy = 'false';
      button.removeAttribute('aria-busy');
      if (label) label.textContent = 'Could not add. Tap to try again';
      window.setTimeout(() => {
        if (label && button.dataset.busy === 'false') label.textContent = originalLabel;
      }, 3200);
    }
  }, true);
})();

/* RVVL live preorder pack confirmation: add only from the sticky bar */
(() => {
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-rvvl-pack-add-selected]');
    const selected = document.querySelector('input[name="rvvl-pack-tier"]:checked');
    if (!button || !selected || button.disabled || button.dataset.busy === 'true') return;

    const variantId = Number(selected.value);
    const status = button.querySelector('[data-rvvl-pack-button-label]');
    const originalStatus = status?.textContent || '';
    button.dataset.busy = 'true';
    button.setAttribute('aria-busy', 'true');
    if (status) status.textContent = 'Adding selected pack…';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            properties: {
              _rvvl_candidate_id: selected.dataset.candidateId || '',
              _rvvl_candidate: selected.dataset.candidateName || '',
              _rvvl_candidate_slug: selected.dataset.candidateSlug || '',
              _rvvl_offer_type: 'physical-preorder',
              _rvvl_vote: '0',
              _rvvl_terms_version: '2026-08-29'
            }
          }]
        })
      });
      if (!response.ok) throw new Error('Cart add failed');

      button.classList.add('is-selected');
      if (status) status.textContent = 'Added ✓ · opening your cart';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'rvvl_preorder_pack_add', variant_id: variantId });

      sessionStorage.setItem('rvvl-reopen-cart', '1');
      const next = new URL(window.location.href);
      next.searchParams.set('open_cart', '1');
      window.setTimeout(() => window.location.assign(next.pathname + next.search + '#choose-your-pack'), 280);
    } catch (error) {
      button.dataset.busy = 'false';
      button.removeAttribute('aria-busy');
      if (status) status.textContent = 'Could not add · tap to try again';
      window.setTimeout(() => {
        if (status && button.dataset.busy === 'false') status.textContent = originalStatus;
      }, 3200);
    }
  });
})();


;(() => {
  if (window.__rvvlPricingScrollBound) return;
  window.__rvvlPricingScrollBound = true;

  document.addEventListener('click', (event) => {
    const origin = event.target instanceof Element ? event.target : event.target?.parentElement;
    const trigger = origin?.closest('.rvvl-commerce a[href="#choose-your-pack"], .rvvl-commerce a[href="#choose-your-impact"]');
    if (!trigger) return;

    const targetId = trigger.getAttribute('href')?.slice(1);
    const target = targetId ? document.getElementById(targetId) : null;
    if (!target) return;

    event.preventDefault();

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = reduceMotion ? 'auto' : 'smooth';
    const pageScroller = document.querySelector('.page-wrapper');
    const scrollContainer = pageScroller && pageScroller.scrollHeight > pageScroller.clientHeight
      ? pageScroller
      : document.scrollingElement;

    if (scrollContainer) {
      const containerTop = scrollContainer === document.scrollingElement
        ? 0
        : scrollContainer.getBoundingClientRect().top;
      const targetTop = target.getBoundingClientRect().top - containerTop + scrollContainer.scrollTop - 88;
      scrollContainer.scrollTo({ top: Math.max(0, targetTop), behavior });
    } else {
      target.scrollIntoView({ behavior, block: 'start' });
    }

    const nextUrl = window.location.pathname + window.location.search + '#' + targetId;
    window.history.replaceState(null, '', nextUrl);
  }, true);
})();



(() => {
  const root=document.querySelector('[data-rvvl-preorder-configurator]');
  if(!root||root.dataset.initialized==='true')return;
  root.dataset.initialized='true';document.documentElement.classList.add('rvvl-preorder-config-ready');
  const slug=root.dataset.candidateSlug||'',candidateId=root.dataset.candidateId||'',candidateName=root.dataset.candidateName||'';
  const priorityVariant=Number(root.dataset.priorityVariant||0),priorityPrice=Number(root.dataset.priorityPriceCents||0);
  const recipeVariant=Number(root.dataset.recipeVariant||0),recipePrice=Number(root.dataset.recipePriceCents||0);
  const membershipVariant=Number(root.dataset.membershipVariant||0),membershipPrice=Number(root.dataset.membershipPriceCents||0),membershipPlan=Number(root.dataset.membershipSellingPlan||0);
  const configNode=document.querySelector('[data-rvvl-commerce-config]');let config={};try{config=JSON.parse(configNode&&configNode.textContent||'{}')}catch(_){}
  const boostVariants=Array.isArray(config&&config.rd_boost&&config.rd_boost.variants)?config.rd_boost.variants:[];
  const expanded=root.querySelector('[data-rvvl-preorder-expanded]'),submitButtons=root.querySelectorAll('[data-rvvl-preorder-submit]'),status=root.querySelector('[data-rvvl-preorder-status]');
  const packInputs=Array.from(root.querySelectorAll('[data-rvvl-preorder-pack]')),strength=root.querySelector('[data-rvvl-preorder-strength]'),strengthLabel=root.querySelector('[data-rvvl-preorder-strength-label]');
  const fuelRange=root.querySelector('[data-rvvl-preorder-fuel]'),fuelMarks=root.querySelector('[data-rvvl-preorder-fuel-marks]'),fuelAmount=root.querySelector('[data-rvvl-preorder-fuel-amount]'),fuelReward=root.querySelector('[data-rvvl-preorder-fuel-reward]');
  const toggles={membership:root.querySelector('[data-rvvl-preorder-toggle="membership"]'),priority:root.querySelector('[data-rvvl-preorder-toggle="priority"]'),recipe:root.querySelector('[data-rvvl-preorder-toggle="recipe"]')};
  const state={membership:false,priority:false,recipe:false,boostIndex:0,busy:false};
  const labels=['Starter pack','Popular pick','Best balance','Best deal','Maximum stash'];
  const boostCopy=['Your preorder is ready without extra R&D support.','Adds a focused boost behind the next candidate questions.','Creates more room for comparisons and feasibility work.','Builds meaningful runway for targeted tests and sourcing.','Puts substantial support behind the remembered details.','Creates major runway for candidate-specific development.','Maximum listed R&D support for this candidate.'];
  const money=cents=>'$'+(Number(cents||0)/100).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
  const selectedPack=()=>packInputs.find(input=>input.checked&&!input.disabled)||packInputs.find(input=>!input.disabled);
  const selectedBoost=()=>state.boostIndex>0?boostVariants[state.boostIndex-1]:null;
  const analytics=(event,detail)=>{const payload=Object.assign({candidate_id:candidateId,candidate_name:candidateName},detail||{});if(window.RVVLMeta)window.RVVLMeta.track(event,payload);else{window.dataLayer=window.dataLayer||[];window.dataLayer.push(Object.assign({event:event},payload))}};
  const setExpanded=next=>{root.classList.toggle('is-expanded',next);root.dataset.expanded=next?'true':'false';expanded.setAttribute('aria-hidden',next?'false':'true');document.documentElement.classList.toggle('rvvl-preorder-config-open',next);if(next){analytics('rvvl_preorder_configurator_open');window.setTimeout(()=>root.querySelector('[data-rvvl-preorder-collapse]').focus({preventScroll:true}),80)}};
  const toggleOnLabels={membership:'Club selected',priority:'Priority selected',recipe:'Recipe selected'},toggleOffLabels={membership:'Join the club',priority:'Add priority',recipe:'Add recipe'};const setToggle=(name,next)=>{state[name]=!!next;const button=toggles[name];if(!button)return;const card=button.closest('.rvvl-preorder-configurator__addon');button.setAttribute('aria-pressed',state[name]?'true':'false');card.classList.toggle('is-selected',state[name]);card.dataset.selectionState=state[name]?'selected':'available';const label=button.querySelector('[data-rvvl-toggle-label]');if(label)label.textContent=state[name]?(toggleOnLabels[name]||'Selected'):(toggleOffLabels[name]||'Include')};
  const update=()=>{let pack=selectedPack();if(pack&&!pack.checked)pack.checked=true;packInputs.forEach(input=>input.closest('.rvvl-preorder-configurator__pack').classList.toggle('is-selected',input===pack));const packIndex=Math.max(0,packInputs.indexOf(pack)),fill=Math.max(20,Math.round((packIndex+1)/Math.max(1,packInputs.length)*100));if(strength)strength.style.setProperty('--rvvl-strength',fill+'%');if(strengthLabel)strengthLabel.textContent=labels[packIndex]||'Selected pack';const boost=selectedBoost(),boostCents=boost?Number(boost.amount||0)*100:0;if(fuelAmount)fuelAmount.textContent=boost?'+$'+Number(boost.amount).toLocaleString('en-US'):'$0';if(fuelReward)fuelReward.textContent=boostCopy[Math.min(state.boostIndex,boostCopy.length-1)];if(fuelRange)fuelRange.value=String(state.boostIndex);const fuelProgress=Math.round(state.boostIndex/Math.max(1,boostVariants.length)*100),fuelCard=fuelRange&&fuelRange.closest('.rvvl-preorder-configurator__addon--fuel');root.style.setProperty('--rvvl-fuel-progress',fuelProgress+'%');if(fuelRange)fuelRange.style.setProperty('--rvvl-fuel-progress',fuelProgress+'%');if(fuelCard)fuelCard.dataset.fuelIntensity=state.boostIndex===0?'idle':state.boostIndex<=2?'building':state.boostIndex<=5?'strong':'maximum';if(fuelRange)fuelRange.setAttribute('aria-valuetext',boost?Number(boost.amount).toLocaleString('en-US')+' dollar R&D Boost':'No extra R&D Boost');root.querySelectorAll('[data-rvvl-fuel-mark]').forEach((mark,index)=>{mark.classList.toggle('is-selected',index===state.boostIndex);mark.setAttribute('aria-pressed',index===state.boostIndex?'true':'false')});let total=pack?Number(pack.dataset.priceCents||0):0;if(state.priority)total+=priorityPrice;if(state.recipe)total+=recipePrice;if(state.membership)total+=membershipPrice;total+=boostCents;root.querySelectorAll('[data-rvvl-preorder-total]').forEach(node=>node.textContent=money(total));submitButtons.forEach(button=>button.disabled=state.busy||!pack)};
  const buildFuelMarks=()=>{if(!fuelRange)return;fuelRange.max=String(boostVariants.length);const defaultIndex=boostVariants.findIndex(item=>Number(item.amount)===10);state.boostIndex=defaultIndex>=0?defaultIndex+1:0};
  const syncFromCart=async()=>{try{const cart=await fetch('/cart.js',{headers:{Accept:'application/json'}}).then(response=>response.json());const sameCandidate=item=>(item.properties||{})._rvvl_candidate_slug===slug;const physical=cart.items.find(item=>sameCandidate(item)&&(item.properties||{})._rvvl_offer_type==='physical-preorder');if(physical){const input=packInputs.find(candidate=>Number(candidate.value)===Number(physical.variant_id));if(input&&!input.disabled)input.checked=true}setToggle('priority',!!cart.items.find(item=>Number(item.variant_id)===priorityVariant));setToggle('recipe',!!cart.items.find(item=>Number(item.variant_id)===recipeVariant));setToggle('membership',!!cart.items.find(item=>Number(item.variant_id)===membershipVariant));const boostLine=cart.items.find(item=>sameCandidate(item)&&(item.properties||{})._rvvl_offer_type==='rd-boost');if(boostLine){const boostIndex=boostVariants.findIndex(item=>Number(item.variant_id)===Number(boostLine.variant_id));if(boostIndex>=0)state.boostIndex=boostIndex+1}}catch(_){}update()};
  const submit=async()=>{if(state.busy)return;const pack=selectedPack();if(!pack)return;state.busy=true;status.textContent='Preparing your preorder checkout…';submitButtons.forEach(button=>{button.disabled=true;const copy=button.querySelector('[data-rvvl-submit-copy]');if(copy)copy.textContent='Preparing checkout'});try{const cart=await fetch('/cart.js',{headers:{Accept:'application/json'}}).then(response=>response.json());const configurable=cart.items.filter(item=>{const properties=item.properties||{},sameCandidate=properties._rvvl_candidate_slug===slug,type=properties._rvvl_offer_type||'';return(sameCandidate&&['physical-preorder','priority-access','rd-boost'].includes(type))||Number(item.variant_id)===recipeVariant||Number(item.variant_id)===membershipVariant});if(configurable.length){const updates={};configurable.forEach(item=>updates[item.key]=0);const removeResponse=await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates:updates})});if(!removeResponse.ok)throw new Error('Could not update the existing configuration.')}const items=[{id:Number(pack.value),quantity:1,properties:{_rvvl_candidate_id:candidateId,_rvvl_candidate:candidateName,_rvvl_candidate_slug:slug,_rvvl_offer_type:'physical-preorder',_rvvl_vote:'0',_rvvl_terms_version:'2026-08-30'}}];if(state.priority&&priorityVariant)items.push({id:priorityVariant,quantity:1,properties:{_rvvl_candidate_id:candidateId,_rvvl_candidate:candidateName,_rvvl_candidate_slug:slug,_rvvl_offer_type:'priority-access',_rvvl_fulfillment_priority:'first-december-group',_rvvl_access_ack:'accepted',_rvvl_terms_version:'2026-08-30'}});const boost=selectedBoost();if(boost&&Number(boost.variant_id))items.push({id:Number(boost.variant_id),quantity:1,properties:{_rvvl_candidate_id:candidateId,_rvvl_candidate:candidateName,_rvvl_candidate_slug:slug,_rvvl_offer_type:'rd-boost',_rvvl_vote:'0',_rvvl_fuel:String(boost.amount||0),_rvvl_terms_version:'2026-08-30'}});if(state.recipe&&recipeVariant)items.push({id:recipeVariant,quantity:1,properties:{_rvvl_candidate_id:candidateId,_rvvl_candidate:candidateName,_rvvl_candidate_slug:slug,_rvvl_offer_type:'sop',_rvvl_vote:'1',_rvvl_terms_version:'2026-08-30'}});if(state.membership&&membershipVariant){const membershipItem={id:membershipVariant,quantity:1,properties:{_rvvl_offer_type:'membership',_rvvl_terms_version:'2026-08-30'}};if(membershipPlan)membershipItem.selling_plan=membershipPlan;items.push(membershipItem)}const addResponse=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items})});if(!addResponse.ok){let detail={};try{detail=await addResponse.json()}catch(_){}throw new Error(detail.description||'Could not add this configuration.')}analytics('rvvl_preorder_configurator_checkout',{item_count:items.length,pack_variant_id:Number(pack.value),boost_amount:boost?Number(boost.amount):0});status.textContent='Configuration ready. Opening secure checkout…';window.location.assign('/checkout')}catch(error){state.busy=false;status.textContent=error&&error.message?error.message:'That configuration could not be prepared. Please try again.';submitButtons.forEach(button=>{const copy=button.querySelector('[data-rvvl-submit-copy]');if(copy)copy.textContent='Continue'});update()}};
  buildFuelMarks();packInputs.forEach(input=>input.addEventListener('change',update));if(fuelRange)fuelRange.addEventListener('input',()=>{state.boostIndex=Number(fuelRange.value||0);update()});Object.keys(toggles).forEach(name=>{const button=toggles[name];if(button)button.addEventListener('click',()=>{setToggle(name,!state[name]);update()})});root.querySelectorAll('[data-rvvl-preorder-expand]').forEach(button=>button.addEventListener('click',()=>setExpanded(true)));root.querySelectorAll('[data-rvvl-preorder-collapse]').forEach(button=>button.addEventListener('click',()=>setExpanded(false)));submitButtons.forEach(button=>button.addEventListener('click',submit));document.addEventListener('keydown',event=>{if(event.key==='Escape'&&root.classList.contains('is-expanded'))setExpanded(false)});document.addEventListener('click',event=>{const cartTrigger=event.target.closest&&event.target.closest('[aria-controls="cart-drawer"],[data-testid="cart-drawer-trigger"]');const link=event.target.closest&&event.target.closest('a[href="#choose-your-pack"],a[href="#choose-your-impact"],a[href="#rvvl-preorder-configurator"],[data-rvvl-preorder-open]');if(!cartTrigger&&!link)return;event.preventDefault();event.stopImmediatePropagation();setExpanded(true)},true);update();syncFromCart();
})();
